<template>
  <div class="cigar-Add">
    <el-form ref="form" :model="form" :rules="rules" label-width="125px">
      <el-form-item label="名称（中文）：" prop="cigarName">
        <el-input v-model="form.cigarName"></el-input>
      </el-form-item>
      <el-form-item label="名称（英文）：" prop="cigarEnglishName">
        <el-input v-model="form.cigarEnglishName"></el-input>
      </el-form-item>
      <el-form-item label="品牌系列：" prop="seriesId">
        <el-select
          v-model="form.seriesId"
          placeholder="请选择"
          @change="hanldleClassify"
        >
          <el-option-group
            v-for="group in options"
            :key="group.id"
            :label="group.brandName"
          >
            <el-option
              v-for="item in group.series"
              :key="item.id"
              :label="item.seriesName"
              :value="item.id"
            ></el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="强度：" prop="cigarStrength">
        <i
          class="iconfont iconxin heart"
          :class="{active:index <= currentIndex}"
          v-for="(item,index) in 5"
          :key="index"
          @click="selectTag(index)"
        ></i>
      </el-form-item>
      <el-form-item label="形状：" prop="cigarShape">
        <el-input v-model="form.cigarShape"></el-input>
      </el-form-item>
      <el-form-item label="长：" prop="cigarLong">
        <el-input v-model="form.cigarLong"></el-input>
      </el-form-item>
      <el-form-item label="口味：" prop="cigarFlavor">
        <el-input v-model="form.cigarFlavor"></el-input>
      </el-form-item>
      <el-form-item label="环：" prop="cigarRing">
        <el-input v-model="form.cigarRing"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="cigarSort">
        <el-input v-model="form.cigarSort"></el-input>
      </el-form-item>
      <el-form-item label="详细介绍：" prop="cigarDetail">
        <el-input type="textarea" v-model="form.cigarDetail"></el-input>
      </el-form-item>
      <el-form-item label="图片：" class="uploadImg" prop="cigarUrl">
        <upload
          :url="form.cigarUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传690*300尺寸。"
        />
      </el-form-item>
      <el-form-item class="submit">
        <el-button
          :loading="loading"
          type="primary"
          @click="onSubmit('form')"
        >保存</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updateCigar, getAllBrandListAndSeries, getCigar } from '@/api/goods';
import Upload from '@/components/Upload/index.vue';
import { validCurrency } from '@/utils/validate';

export default {
  name: 'CigarEditor',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      loading: false,
      currentIndex: -1,
      form: {
        id: '',
        cigarName: '',
        cigarEnglishName: '',
        brandId: '',
        seriesId: '',
        cigarStrength: -1,
        cigarLong: '',
        cigarFlavor: '',
        cigarRing: '',
        cigarSort: '',
        cigarDetail: '',
        cigarUrl: '',
        cigarShape: '',
      },
      options: [],
      rules: {
        cigarName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' },
        ],
        cigarEnglishName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
        ],
        seriesId: [
          { required: true, message: '请选择品牌分类', trigger: 'change' },
        ],
        cigarShape: [
          { required: true, message: '形状不能为空', trigger: 'blur' },
        ],
        cigarLong: [
          { required: true, message: '长度不能为空', trigger: 'blur' },
        ],
        cigarFlavor: [
          { required: true, message: '请输入所选口味', trigger: 'blur' },
        ],
        cigarRing: [
          { required: true, message: '环不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
        cigarSort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
        cigarDetail: [
          { required: true, message: '详细介绍不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  components: {
    Upload,
  },
  mounted() {
    this.getAllBrandListAndSeries();
    this.getCigar();
  },
  methods: {
    // 获取详情信息
    getCigar() {
      const { id } = this.$route.query;
      getCigar(id).then((res) => {
        if (res.success) {
          const { cigarStrength } = res.data;
          this.currentIndex = cigarStrength - 1;
          Object.keys(this.form).forEach((key) => {
            this.form[key] = res.data[key];
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取分类
    getAllBrandListAndSeries() {
      getAllBrandListAndSeries().then((res) => {
        if (res.success) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    updateCigar() {
      this.loading = true;
      updateCigar(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('编辑成功');
          this.$router.push({ name: 'CigarList' });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.cigarStrength === -1) {
            this.$message.warning('请选择强度大小');
            return false;
          }
          if (!this.form.cigarUrl) {
            this.$message.warning('请上传商品图片');
            return false;
          }
          this.updateCigar();
          return true;
        }
        return false;
      });
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'CigarList' });
    },
    hanldleClassify(val) {
      this.options.map((item) => {
        item.series.forEach((items) => {
          if (items.id === val) {
            this.form.brandId = item.id;
          }
        });
        return false;
      });
    },
    handleSuccessUpload(url) {
      this.form.cigarUrl = url;
    },
    selectTag(index) {
      if (index === 0 && this.currentIndex === 0) {
        this.currentIndex = -1;
      } else {
        this.currentIndex = index;
      }
      this.form.cigarStrength = this.currentIndex + 1;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.cigar-Add
  .el-form
    width 700px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
  .heart
    cursor pointer
    color #ccc
    font-size 20px
    margin-right 5px
  .active
    color red
</style>
